import React, { useState, useEffect, useRef } from "react";
import "./WipReport.scss";
import Header from "../../Home/Header/Header";
import { DataGrid } from "@mui/x-data-grid";
import {
  CircularProgress,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { IoIosSearch, IoMdClose } from "react-icons/io";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import CustomTextField from "../../../TextFiled/Index";

const WipReport = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const gridRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 130}px`;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("Report_wip_jobcount")
      .then((response) => {
        if (response?.Data?.DT) {
          const formattedData = response.Data.DT.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setSaleData(formattedData);
          setFilteredData(formattedData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to fetch stock data. Please try again.");
        setIsLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchQuery(searchValue);
    const filteredSales = saleData.filter((sale) => {
      return (
        sale.CustomerCode.toLowerCase().includes(searchValue) ||
        sale.productionstatus.toLowerCase().includes(searchValue)
      );
    });
    setFilteredData(filteredSales);
  };

  const columns = [
    {
      field: "CustomerCode",
      headerName: "Customer Code",
      width: 160,
    },
    {
      field: "jobcount",
      headerName: "Jobs",
      width: 90,
    },

    {
      field: "productionstatus",
      headerName: "Status",
      width: 150,
    },
  ];

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredData(saleData);
  };

  return (
    <div className="employee_main">
      <Header otherPage={true} title="WIP Report" />
      <div style={{ padding: "65px 5px 5px 5px" }}>
        <Box mb={2}>
          <CustomTextField
            className="searchBox_input"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search ..."
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton onClick={clearSearch}>
                  <IoMdClose className="catelog_searchClose_icone" />
                </IconButton>
              ),
            }}
          />
        </Box>
        <div
          ref={gridRef}
          style={{
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <DataGrid
            rows={filteredData || []}
            columns={columns}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15, 25, 50]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pagination
            loading={isLoading}
            localeText={{ noRowsLabel: "No Data" }}
            components={{
              Toolbar: () => null,
              LoadingOverlay: () => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  Loading...
                </div>
              ),
            }}
            className="employee_datagrid"
          />
        </div>
      </div>
    </div>
  );
};

export default WipReport;
